import {
  ApiAddProductToMyWishlistRequestedAction,
  apiAddProductToMyWishlistFailed,
  apiAddProductToMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/addProductToMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import addProductToMyWishlistAction from '@spa/lib/actions/wishlists/addProductToMyWishlistAction';
import logger from '@spa/lib/logger';

function* addProductToMyWishlistApiSaga({
  payload: { actionId: requestedActionId, input, parentActionId }
}: ApiAddProductToMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(addProductToMyWishlistAction, 'addProductToMyWishlistAction', input);

    if (result.__typename === 'AddProductToMyWishlistSucceededResult') {
      yield* put(
        apiAddProductToMyWishlistSucceeded({
          parentActionId,
          requestedActionId,
          result: result.wishlists
        })
      );
    } else {
      yield* put(
        apiAddProductToMyWishlistFailed({ error: result.error, parentActionId, requestedActionId })
      );
    }
  } catch (e) {
    logger.error(e, 'Error adding product to my wishlist');

    yield* put(
      apiAddProductToMyWishlistFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default addProductToMyWishlistApiSaga;
